module.exports = __webpack_public_path__ + "static/media/information.058d5489.svg";